import AttendantDashboardView from "@/views/attendant/dashboard/DashboardView";
import MyAccountView from "@/views/MyAccountView";

export default [
  {
    name: "pages.attendant.dashboard",
    path: "dashboard",
    component: AttendantDashboardView
  },
  {
    name: "pages.attendant.my-account",
    path: "my-account",
    component: MyAccountView
  }
];
